import { QueryEntity } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { MatOrderState, MatOrderStore } from './mat-order.store';

@Injectable({
	providedIn: 'root'
})
export class MatOrderQuery extends QueryEntity<MatOrderState> {
	searchQuery$ = this.select(state => state.ui.searchQuery);

	constructor(protected store: MatOrderStore) {
		super(store);
	}
}
